<mat-toolbar class="subtitulo">Cadastrar Acesso</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <form #formCadastro="ngForm">

        <!-- UNIDADE -->
        <mat-toolbar class="titulopartes">Instituição</mat-toolbar>
        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

            <mat-form-field fxFlex= "95%" fxFlexOffset="20px">
                <mat-label>Selecione a Instituição</mat-label>
                <mat-select name="instituicao"
                           [(ngModel)]="cadastroAcesso.idInstituicao"
                           [disabled]="isAtualizar" required
                           (selectionChange)="instituicaoSelecionada()">
                    <mat-option></mat-option>       
                    <mat-option *ngFor="let u of instituicoes" [value]="u.id">
                        {{u.nome}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </div>

        <!-- USUÁRIO -->
        <mat-toolbar class="titulopartes">Usuário</mat-toolbar>
        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
             <mat-form-field fxFlex= "95%" fxFlexOffset="20px">
                <mat-label>Selecione um usuário</mat-label>
                <mat-select name="usuario" [(ngModel)]="cadastroAcesso.idUsuario"
                    [disabled]="!cadastroAcesso.idInstituicao || isAtualizar" required>
                    <mat-option *ngFor="let u of usuarios" [value]="u.idUsuario">
                        {{u.nomeCompleto}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div *ngIf="!isAtualizar; else divAlterar">

            <!-- PERFIL -->
            <mat-toolbar class="titulopartes">Perfil</mat-toolbar>
            <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
                    <mat-form-field fxFlex= "95%" fxFlexOffset="20px">
                    <mat-label>Escolha o perfil</mat-label>
                    <mat-select name="perfil" [(ngModel)]="cadastroAcesso.idPerfilAcesso"
                        [disabled]="!cadastroAcesso.idInstituicao" required>
                        <mat-option *ngFor="let p of perfis" [value]="p.id">
                            {{p.nome}}
                        </mat-option>
                    </mat-select>

                </mat-form-field>
            </div>

            <mat-toolbar class="titulopartes">Módulos</mat-toolbar>
            <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
                <mat-form-field fxFlex="95%" fxFlexOffset="20px">
                    <mat-select placeholder="Módulos"
                                [(ngModel)]="moduloSelecionados"
                                name="modulo_perfil"
                                multiple
                                [disabled]="!cadastroAcesso.idInstituicao"
                                required>
                        <mat-select-trigger>
                            {{moduloSelecionados ? moduloSelecionados[0]?.descricao: ''}}
                            <span *ngIf="moduloSelecionados?.length > 1">
                                (+{{moduloSelecionados.length - 1}} {{moduloSelecionados?.length === 2 ? 'outro' : 'outros'}})
                            </span>
                        </mat-select-trigger>
                        <mat-option *ngFor="let m of modulos" [value]="m">
                            {{m.descricao}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

        </div>

        <ng-template #divAlterar>

            <!-- MODULO -->
            <mat-toolbar class="titulopartes">Módulo</mat-toolbar>
            <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
                <mat-form-field fxFlex= "95%" fxFlexOffset="20px">
                    <mat-label>Selecione o módulo</mat-label>
                    <mat-select name="modulo"
                                [(ngModel)]="cadastroAcesso.idModulo"
                                required
                                [disabled]="!cadastroAcesso.idUsuario || isAtualizar"
                                (selectionChange)="buscarPerfis()">
                        <mat-option *ngFor="let m of modulos" [value]="m.id">
                            {{m.descricao}}
                        </mat-option>
                    </mat-select>

                </mat-form-field>
            </div>

            <!-- PERFIL -->
            <mat-toolbar class="titulopartes">Perfil</mat-toolbar>
            <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
                    <mat-form-field fxFlex= "95%" fxFlexOffset="20px">
                    <mat-label>Escolha o perfil</mat-label>
                    <mat-select name="perfil" [(ngModel)]="cadastroAcesso.idPerfilAcesso"
                                [disabled]="!cadastroAcesso.idModulo" required>
                        <mat-option *ngFor="let p of perfis" [value]="p.id">
                            {{p.nome}}
                        </mat-option>
                    </mat-select>

                </mat-form-field>
            </div>
        </ng-template>



        <!-- BOTOES -->
        <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>
            <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button
                    name="botaoConfirmar"
                    fxFlex="20%"
                    color="primary"
                    [disabled]="formCadastro.invalid"
                    (click)="cadastrar()"> Cadastrar
            </button>

            <button *ngIf="isAtualizar && mostrarBotaoAtualizar" mat-raised-button
                    name="botaoConfirmar"
                    fxFlex="20%"
                    color="primary"
                    [disabled]="formCadastro.invalid"
                    (click)="atualizar()">
                    Atualizar
            </button>

            <button *ngIf="mostrarBotaoLimpar()"
                    mat-raised-button
                    fxFlex="20%"
                    (click)="limpar()">
                    Limpar
            </button>
            <button
                    mat-raised-button
                    fxFlex="20%"
                    (click)="cancelar()">
                    Cancelar
            </button>

        </div>

    </form>
</div>

